export default {
  path: '/users/:id',
  name: 'User',
  component: () => import(/* webpackChunkName: "base" */ '../views/UserView.vue')
}
